import * as React from 'react';
import {connect} from 'react-redux';

class SimpleInputAgGridRenderer extends React.Component{

    render(){
      const {finSchemaErrors,column,finStrIndex} = this.props;
      console.log(finSchemaErrors)
      return(
        <div style={{position: 'relative'}}>
          <p>{this.props.value}</p>
          <p style={{
            position: 'absolute',
            top: '0',
            left: '-10px',
            color: 'red'
          }}>
            {finSchemaErrors && !finStrIndex && finSchemaErrors[column.colId] && finSchemaErrors[column.colId]}
          </p>
        </div>
      )
    }
  }

  const mapStateToProps = state => {
  return {
    finSchemaErrors: state.financicalSchemas.finSchemaErrors,
  }
};
export default connect(mapStateToProps)(SimpleInputAgGridRenderer);


// WEBPACK FOOTER //
// ./src/views/FinancicalStructure/FinancicalStructure/FieldRenderer/SimpleInputAgGridRenderer.js